import React from 'react';
import { StyledMissionsBanner } from './MissionsBanner.styled';

const MissionsBanner = ({ title, subtitle, logoSrc }) => {
  return (
    <StyledMissionsBanner>
      {logoSrc && (
        <div className='missions-banner-logo-container'>
          <img className='missions-banner-logo' src={logoSrc} alt="Missions logo" />
        </div>
      )}
      <div className='missions-banner-main-text'>
        {title}
      </div>
      {subtitle && (
        <div className='missions-banner-secondary-text'>
          {subtitle}
        </div>
      )}
    </StyledMissionsBanner>
  );
};

// Default props
MissionsBanner.defaultProps = {
  title: 'Missions',
  subtitle: 'Complete quests, unlock gear',
  logoSrc: null
};

export default MissionsBanner;